module.exports = __webpack_public_path__ + "img/envelope.c2cd702c.svg";